export default __webpack_public_path__ + "static/media/typearrow.90e1c901.svg";